import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GrantsDatashareService {

  public _GrantApplicationID = new BehaviorSubject<string>("");
  GrantApplicationID = this._GrantApplicationID.asObservable();

  public _CharityID = new BehaviorSubject<string>("");
  CharityID = this._CharityID.asObservable();

  public _CMEID = new BehaviorSubject<string>("");
  CMEID = this._CMEID.asObservable();

  public _SPONSORSHIPID = new BehaviorSubject<string>("");
  SPONSORSHIPID = this._SPONSORSHIPID.asObservable();

  setGrantApplicationID(value: string) {
    this._GrantApplicationID.next(value);
  }
  setCharityID(value: string) {
    this._CharityID.next(value);
  }
  setCMEID(value: string) {
    this._CMEID.next(value);
  }
  setSPONSORSHIPID(value: string) {
    this._SPONSORSHIPID.next(value);
  }
}
